import { render, staticRenderFns } from "./RankingTable.vue?vue&type=template&id=418867cc&scoped=true"
import script from "./RankingTable.vue?vue&type=script&lang=js"
export * from "./RankingTable.vue?vue&type=script&lang=js"
import style0 from "./RankingTable.vue?vue&type=style&index=0&id=418867cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418867cc",
  null
  
)

export default component.exports